<template>
  <div>
    <div class="btnitem" @click="invitation">
      <img style="width:19px;height:19px" src="@/assets/linshiyonggong/yaoqin.png"/>
      <span>邀请</span>
    </div>
  </div>
</template>

<script>
import {checkDataStatus} from "@/utils/checkDataStatus"
import { apiHome } from "@/api/apiHome"
export default {
  name: "invitation",
  props:{
    item:{
      type:Object,
      default(){
        return {}
      }
    },
    type: {
      type: [Number,String] // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    }
  },
  data(){
    return {}
  },
  methods:{
    // 调用工具方法检测数据有效性
    async validData(){
      const state = await checkDataStatus(5,this.item.no)
      if(!state){
        this.$message.error('系统异常，请稍后再试')
        return false
      }
      this.state = state
      return this.state==1
    },
    /** @name 邀请加盟-弹框 */
    async invitation() {
      const rules = {}
      if(this.permissionTips(rules)) return
      if(!await this.validData()){
        return
      }
      const { data: res } = await apiHome.getIdentifiers();
			const arr = res.result.identifiers
			const InviteJoinListC = arr.some(i=>i==='InviteJoinListC')//邀请权限
      let isCompany = this.$store.state.user.type === 1//企业
      let isPersonal = this.$store.state.user.type === 0//个人
      let isRelevance =(this.$store.state.user.type === 1||this.$store.state.user.type === 0)&&this.$store.state.user.relevance
      if ((isCompany || isPersonal) && isRelevance) {
        if(InviteJoinListC){
          if(this.item.companyNo&&this.item.companyNo!=this.$store.state.user.companyNo){
            const query=`${process.env.VUE_APP_VIP}/joinInfo/?no=${this.item.companyNo}&type=0&personal=0&isApproval=0`
            window.open(query,'_blank')
          }else if(isPersonal&&this.item.isCompany==0&&this.item.userNo==this.$store.state.user.no){
            this.$message.error("操作失败，不能对自己发布的内容进行该操作")
          }else if(!this.item.companyNo&&this.item.isCompany!==2){
            this.$message.error("该工队暂未认证企业,暂时无法加盟!")
          }else if(this.item.companyNo==this.$store.state.user.companyNo){
            this.$message.error("操作失败，不能对同企业发布的内容进行该操作")
          }else if(this.item.isCompany==2){
            this.$message.error("发布方为团队身份，暂无邀请加盟权限")
          }
        }else{
          this.$message.error("您没有权限，请联系管理员开通!")
        }
      } else{
        this.$message.error("请切换至企业/个人身份才可以申请邀请")
      }
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
